import { calculateTaxesSumma } from "./taxUtil";

export const calcPriceFromGrossPrice = (grossPrice, taxes) => {
  const value = parseFloat(grossPrice);
  if (!value) return 0;
  var total_rate = 0;
  taxes?.forEach((tax) => (total_rate += (tax?.rate || 0) <= 0 ? 0 : tax.rate));
  return value * (100 / (100 + total_rate));
};

export const calcGrossPriceFromPrice = (price, taxes) => {
  const value = parseFloat(price);
  if (!value) return 0;
  return value + calculateTaxesSumma(value, taxes);
};
